export const ALL_TEMP_TRANSFER_REQUEST = "ALL_TEMP_TRANSFER_REQUEST"
export const ALL_TEMP_TRANSFER_SUCCESS = "ALL_TEMP_TRANSFER_SUCCESS"
export const ALL_TEMP_TRANSFER_FAIL = "ALL_TEMP_TRANSFER_FAIL"

export const TEMP_TRANSFER_DETIALS_REQUEST = "TEMP_TRANSFER_DETIALS_REQUEST"
export const TEMP_TRANSFER_DETIALS_SUCCESS = "TEMP_TRANSFER_DETIALS_SUCCESS"
export const TEMP_TRANSFER_DETIALS_FAIL = "TEMP_TRANSFER_DETIALS_FAIL"

export const TEMP_TRANSFER_ON_SHOP_REQUEST = "TEMP_TRANSFER_ON_SHOP_REQUEST"
export const TEMP_TRANSFER_ON_SHOP_SUCCESS = "TEMP_TRANSFER_ON_SHOP_SUCCESS"
export const TEMP_TRANSFER_ON_SHOP_FAIL = "TEMP_TRANSFER_ON_SHOP_FAIL"

export const POST_TEMP_TRANSFER_REQUEST = "POST_TEMP_TRANSFER_REQUEST"
export const POST_TEMP_TRANSFER_SUCCESS = "POST_TEMP_TRANSFER_SUCCESS"
export const POST_TEMP_TRANSFER_FAIL = "POST_TEMP_TRANSFER_FAIL"


export const ALL_TEMP_TRANSFER_DELETE_REQUEST = "ALL_TEMP_TRANSFER_DELETE_REQUEST"
export const ALL_TEMP_TRANSFER_DELETE_SUCCESS = "ALL_TEMP_TRANSFER_DELETE_SUCCESS"
export const ALL_TEMP_TRANSFER_DELETE_FAIL = "ALL_TEMP_TRANSFER_DELETE_FAIL"

export const DELETE_TEMP_TRANSFER_PRODUCT_REQUEST = "DELETE_TEMP_TRANSFER_PRODUCT_REQUEST"
export const DELETE_TEMP_TRANSFER_PRODUCT_SUCCESS = "DELETE_TEMP_TRANSFER_PRODUCT_SUCCESS"
export const DELETE_TEMP_TRANSFER_PRODUCT_FAIL = "DELETE_TEMP_TRANSFER_PRODUCT_FAIL"


export const UPDATE_TEMP_TRANSFER_PRODUCT_ITEM_REQUEST = "UPDATE_TEMP_TRANSFER_PRODUCT_ITEM_REQUEST"
export const UPDATE_TEMP_TRANSFER_PRODUCT_ITEM_SUCCESS = "UPDATE_TEMP_TRANSFER_PRODUCT_ITEM_SUCCESS"
export const UPDATE_TEMP_TRANSFER_PRODUCT_ITEM_FAIL = "UPDATE_TEMP_TRANSFER_PRODUCT_ITEM_FAIL"

export const UPDATE_TEMP_TRANSFER_PRODUCT_REQUEST = "UPDATE_TEMP_TRANSFER_PRODUCT_REQUEST"
export const UPDATE_TEMP_TRANSFER_PRODUCT_SUCCESS = "UPDATE_TEMP_TRANSFER_PRODUCT_SUCCESS"
export const UPDATE_TEMP_TRANSFER_PRODUCT_FAIL = "UPDATE_TEMP_TRANSFER_PRODUCT_FAIL"

export const CLEAR_ERRORS = "CLEAR_ERRORS"